module.exports = __webpack_public_path__ + "img/材料力学6_1_4.5ed25aba.jpg";